import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildConstructionApiPayload, createConstruction } from '../api/postApi';

const createInitialForm = () => ({
  installationYear: '',
  businessName: '',
  managementNumber: '',
  possessor: '',
  possessorPhoneNumber: '',
  address: '',
  detailAddress: '',
  installationCompany: '',
  contractorManager: '',
  contractorPhoneNumber: '',
  moduleManufacturer: '',
  moduleModelName: '',
  moduleQuantity: '',
  inverterManufacturer: '',
  inverterModelName: '',
  ratedVoltage: '',
  capacity: '',
  inverterQuantity: '',
  inverterCapacity: '',
  junctionBoxYn: '',
  note: '',
});

function PostInstallationCreatePage() {
  const navigate = useNavigate();
  const [form, setForm] = useState(createInitialForm());
  const [saving, setSaving] = useState(false);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await createConstruction(buildConstructionApiPayload(form));
      window.alert('시공정보 등록이 완료되었습니다.');
      navigate('/posts/installation');
    } catch (error) {
      window.alert(`시공정보 등록 실패: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  const onBlockEnterSubmit = (event) => {
    if (event.key !== 'Enter') return;
    if (event.target?.tagName?.toLowerCase() === 'textarea') return;
    event.preventDefault();
  };

  return (
    <section className="page">
      <h2>시공정보 작성</h2>
      <form onSubmit={onSubmit} onKeyDown={onBlockEnterSubmit}>
        <div className="form-sections">
          <section className="form-section">
            <h3>기본 정보</h3>
            <div className="form-grid">
              <label className="field">
                설치연도
                <input name="installationYear" value={form.installationYear} onChange={onChange} />
              </label>
              <label className="field">
                사업명
                <input name="businessName" value={form.businessName} onChange={onChange} />
              </label>
              <label className="field">
                관리번호
                <input name="managementNumber" value={form.managementNumber} onChange={onChange} />
              </label>
              <label className="field">
                설비 소유자
                <input name="possessor" value={form.possessor} onChange={onChange} />
              </label>
              <label className="field">
                설비 소유자 전화번호
                <input name="possessorPhoneNumber" value={form.possessorPhoneNumber} onChange={onChange} />
              </label>
            </div>
          </section>

          <section className="form-section">
            <h3>주소 정보</h3>
            <div className="form-grid">
              <label className="field">
                주소
                <input name="address" value={form.address} onChange={onChange} />
              </label>
              <label className="field">
                상세 주소
                <input name="detailAddress" value={form.detailAddress} onChange={onChange} />
              </label>
            </div>
          </section>

          <section className="form-section">
            <h3>시공 정보</h3>
            <div className="form-grid">
              <label className="field">
                시공 업체
                <input name="installationCompany" value={form.installationCompany} onChange={onChange} />
              </label>
              <label className="field">
                시공 업체 담당자
                <input name="contractorManager" value={form.contractorManager} onChange={onChange} />
              </label>
              <label className="field">
                시공 업체 담당자 전화번호
                <input name="contractorPhoneNumber" value={form.contractorPhoneNumber} onChange={onChange} />
              </label>
              <label className="field">
                접속반 유무
                <select name="junctionBoxYn" value={form.junctionBoxYn ?? ''} onChange={onChange}>
                  <option value="" />
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </label>
            </div>
          </section>

          <section className="form-section">
            <h3>설비 정보</h3>
            <div className="form-grid">
              <label className="field">
                설비 용량(kw)
                <input name="capacity" value={form.capacity} onChange={onChange} />
              </label>
              <label className="field">
                모듈 제조사
                <input name="moduleManufacturer" value={form.moduleManufacturer} onChange={onChange} />
              </label>
              <label className="field">
                모듈 모델명
                <input name="moduleModelName" value={form.moduleModelName} onChange={onChange} />
              </label>
              <label className="field">
                모듈 수량
                <input name="moduleQuantity" value={form.moduleQuantity} onChange={onChange} />
              </label>
              <label className="field">
                인버터 제조사
                <input name="inverterManufacturer" value={form.inverterManufacturer} onChange={onChange} />
              </label>
              <label className="field">
                인버터 모델명
                <input name="inverterModelName" value={form.inverterModelName} onChange={onChange} />
              </label>
              <label className="field">
                정격전압(V)
                <input name="ratedVoltage" value={form.ratedVoltage} onChange={onChange} />
              </label>
              <label className="field">
                인버터 수량
                <input name="inverterQuantity" value={form.inverterQuantity} onChange={onChange} />
              </label>
              <label className="field">
                인버터 용량(kw)
                <input name="inverterCapacity" value={form.inverterCapacity} onChange={onChange} />
              </label>
              <label className="field field-wide">
                기타사항
                <textarea name="note" rows={4} value={form.note} onChange={onChange} />
              </label>
            </div>
          </section>
        </div>

        <div className="button-row">
          <button type="button" className="secondary" onClick={() => navigate('/posts/installation')}>
            목록으로
          </button>
          <button type="submit" disabled={saving}>
            {saving ? '저장 중...' : '저장'}
          </button>
        </div>
      </form>
    </section>
  );
}

export default PostInstallationCreatePage;
